import styled from 'styled-components';
import { TYPOGRAPHY, COLOR } from '../../../../theme/constants';
import { Button } from '@emarketer/componentlibrary';

export const MetricsTableHeadContainer = styled.thead`
  position: relative;

  .popper-tooltip {
    border-radius: 8px;
    z-index: 101;
    -webkit-box-shadow: none;
    box-shadow: none;
    -moz-box-shadow: none;
  }

  .arrow::after {
    width: 18px !important;
    height: 18px !important;
    box-shadow: none !important;
  }

  .popper-tooltip[data-placement='top'] > .arrow {
    bottom: -1px;
  }

  .popper-tooltip[data-placement='bottom'] > .arrow {
    top: -9px;
  }
`;

export const PopperTooltipWrapper = styled.div`
  position: absolute;
  top: 10px;
  left: 12px;
`;

export const TimeframeOverlay = styled.div`
  position: fixed;
  background: rgba(0, 0, 0, 0.4);
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
`;

export const MobileTimeframeManagerWrapper = styled.tr`
  position: absolute;
  top: 9px;
  left: 12px;
`;

export const MobileTimeframeManagerContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: ${COLOR.WHITE};
  border-radius: 8px;
  z-index: 101;
`;

export const TimeframeEditButton = styled(Button)`
  display: flex;
  align-items: center;
  border: 1px solid ${COLOR.BLUE} !important;
  border-radius: 25px;
  color: ${COLOR.BLUE};
  padding: 10px 15px 10px 15px !important;
  margin: 0 0 0 15px;
  text-decoration: none;
  font-size: 12px;
  line-height: 1.4px;
  ${TYPOGRAPHY.LIGHT};
  cursor: pointer;

  &:hover {
    color: ${COLOR.WHITE};
    background-color: ${COLOR.BLUE};
  }

  svg {
    margin-right: 4px;
  }
`;
